// extracted by mini-css-extract-plugin
export default {"section":"IngredientDetails_section__nJCbh","ul":"IngredientDetails_ul__XYBfp"};